import { Flex, Spin } from "antd"
import React, { type ReactNode, useEffect, useState } from "react"
import { Navigate } from "react-router-dom"

import { RoutesPaths } from "../../constants/routes.ts"
import { useAppSelector } from "../../hooks/use-app-selector.ts"

const PERMISSIONS_WAIT_MS = 8000

interface Props {
  children: ReactNode
}

const GlobalMapAvailabilityGate = ({ children }: Props) => {
  const roleId = useAppSelector((state) => state.auth.userInfo?.role?.id)
  const featureGlobalMap = useAppSelector(
    (state) => state.auth.userInfo?.feature_global_map
  )
  const [waitExpired, setWaitExpired] = useState(false)

  useEffect(() => {
    if (roleId !== undefined) return
    const timer = setTimeout(() => setWaitExpired(true), PERMISSIONS_WAIT_MS)
    return () => clearTimeout(timer)
  }, [roleId])

  // On a cold boot the profile loads asynchronously; "unknown" must wait, not
  // redirect — but only for a bounded time, so a failed profile fetch can't
  // strand the user on a spinner.
  if (roleId === undefined && !waitExpired) {
    return (
      <Flex
        align="center"
        justify="center"
        style={{ minHeight: "60vh" }}
        data-testid="global-map-gate-loading"
      >
        <Spin />
      </Flex>
    )
  }

  if (featureGlobalMap !== true) {
    return <Navigate to={RoutesPaths.home} replace />
  }

  return <>{children}</>
}

export default GlobalMapAvailabilityGate
